import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { CartProvider } from "@/contexts/CartContext";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Bundles from "@/pages/Bundles";
import BundleDetail from "@/pages/BundleDetail";
import Cart from "@/pages/Cart";
import Success from "@/pages/Success";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import Personvern from "@/pages/Personvern";
import Vilkar from "@/pages/Vilkar";
import Refusjon from "@/pages/Refusjon";
import Cookies from "@/pages/Cookies";
import ReviewSubmit from "@/pages/ReviewSubmit";
import CookieBanner from "@/components/CookieBanner";
import LaunchBanner from "@/components/LaunchBanner";

function Shell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="App grain">
      {!isAdmin && <LaunchBanner />}
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatBot />}
      {!isAdmin && <CookieBanner />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              {/* Norwegian-localized URLs (primary) */}
              <Route path="/butikk" element={<Shop />} />
              <Route path="/produkt/:slug" element={<ProductDetail />} />
              <Route path="/pakker" element={<Bundles />} />
              <Route path="/pakke/:slug" element={<BundleDetail />} />
              <Route path="/handlekurv" element={<Cart />} />
              <Route path="/om-oss" element={<About />} />
              {/* English aliases (kept for backwards compatibility / old links) */}
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/bundles" element={<Bundles />} />
              <Route path="/bundle/:slug" element={<BundleDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/about" element={<About />} />
              {/* Other (already Norwegian) */}
              <Route path="/success" element={<Success />} />
              <Route path="/personvern" element={<Personvern />} />
              <Route path="/vilkar" element={<Vilkar />} />
              <Route path="/refusjon" element={<Refusjon />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/anmeldelse/:token" element={<ReviewSubmit />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
